import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAtomValue } from "jotai";

import { isAuthenticatedVar } from "@/variables/globalVar";
import App from "@/App";

export function ProtectedApp() {
  const navigate = useNavigate();
  const location = useLocation();
  const isAuthenticated = useAtomValue(isAuthenticatedVar);

  useEffect(() => {
    if (
      !isAuthenticated &&
      location.pathname !== "/login" &&
      location.pathname !== "/signup"
    ) {
      navigate("/login", { replace: true });
    }
  }, [isAuthenticated, location.pathname, navigate]);

  if (!isAuthenticated) {
    return null;
  }

  return <App />;
}

export default ProtectedApp;
